import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDateTime,
} from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";

const InMemoryMemberNotesHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    title: "Title",
    type: new InMemoryString("Title"),
    version: 1,
  }),
  new InMemoryHeader({
    title: "Category",
    type: new InMemoryString("Category"),
    version: 1,
  }),
  new InMemoryHeader({
    title: "Creator",
    type: new InMemoryString("CreatedBy"), 
    version: 1,
  }),
  new InMemoryHeader({
    title: "Timestamp",
    type: new InMemoryDateTime("Timestamp"),
    version: 1,
  }),
  new InMemoryHeader({
    title: "Text",
    type: new InMemoryString("Text"),
    visible: false,
    version: 1,
  }),
];

export default InMemoryMemberNotesHeaders;
